import { SET_SETTING } from '../constants';

export function setSetting(data) {
	return {
		type: SET_SETTING,
		data,
	};
}
